module.exports = __webpack_public_path__ + "img/close.ae21b350.png";